import { getGlobal } from './apiClients/global';
import { dispatchRpcRequest } from './chirp-avro-fetch-base';

/**
 * Loosely models available backend rewrites/shims.
 * eg `runtime.client.call(MyRpc, { request: args })` => backend CHIRP call
 */

/**
 * Marker for client-types code generation.
 * BFF calls should use client-types generated bindings.
 */
export function defineBff(_metadata, f) {
  return f;
}
export function deriveAuthFromDomain(hostname) {
  // local.* hosts (e.g. local.hubspot.com used by the Bend test runner) are
  // internal infrastructure, not customer portals
  if (/\.hubspot(qa)?\.com$/.test(hostname) && !hostname.startsWith('local.')) {
    return 'app';
  }
  return 'internal';
}
function getBffGateway(auth) {
  return `/chirp-bff-${auth}/v1`;
}
export function makeBffCall({
  hubHttpClient,
  details,
  inputs,
  responseParser,
  calledFrom = 'bend',
  rpcFetcherFactory,
  fetcherOverride
}) {
  var _location$hostname, _location, _inputs$args;
  const auth = deriveAuthFromDomain((_location$hostname = (_location = getGlobal().location) === null || _location === void 0 ? void 0 : _location.hostname) !== null && _location$hostname !== void 0 ? _location$hostname : '');
  const {
    timeout,
    portalId,
    userId,
    environment,
    hublet
  } = inputs !== null && inputs !== void 0 ? inputs : {};
  const request = {
    args: [(_inputs$args = inputs === null || inputs === void 0 ? void 0 : inputs.args) !== null && _inputs$args !== void 0 ? _inputs$args : {}]
  };
  const {
    bffHash,
    name
  } = details;
  const syncStackError = new Error(`BFF call failed for ${bffHash}`);
  const clientTimeout = typeof timeout === 'number' ? timeout : 5000;
  const gatewayUrl = `${getBffGateway(auth)}/execute/hash/${bffHash}/${name}`;
  return dispatchRpcRequest({
    gatewayUrl,
    request,
    headers: {},
    auth,
    clientTimeout,
    environment,
    hublet,
    portalId,
    userId,
    calledFrom,
    hubHttpClient,
    rpcFetcherFactory,
    fetcherOverride
  }).then(response => {
    if (response != null && typeof response === 'object' && response.isAuthError === true) {
      throw Object.assign(new Error('Unauthorized'), {
        isAuthError: true
      });
    }
    return responseParser ? responseParser(response) : response;
  }).catch(error => {
    syncStackError.cause = error;
    throw syncStackError;
  });
}
export function createBffClient({
  hubHttpClient,
  fetcherOverride,
  rpcFetcherFactory,
  calledFrom
}) {
  return {
    call: (details, inputs) => makeBffCall({
      hubHttpClient,
      details,
      inputs,
      calledFrom,
      rpcFetcherFactory,
      fetcherOverride
    })
  };
}